export default "__VITE_ASSET__DugR1FLW__"